import { Modal } from "./modal";

const DepositBalance = { Modal };

export default DepositBalance;
